import { render, staticRenderFns } from "./AppointmentWizard.vue?vue&type=template&id=0bfada9d"
import script from "./AppointmentWizard.vue?vue&type=script&lang=js"
export * from "./AppointmentWizard.vue?vue&type=script&lang=js"
import style0 from "./AppointmentWizard.vue?vue&type=style&index=0&id=0bfada9d&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports